import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { Route } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import { HiDocumentReport } from 'react-icons/hi';
import { ReactSVG } from 'react-svg';
import IconReport from '../../Images/icon/report.svg';

MenuManager.RegisterItem({
	key: 'reports',
	path: '/reports',
	position: 3,
	name: 'Отчёты',
	icon: <ReactSVG src={IconReport} />
});

export function ReportsRoute () {
	const reports = useLoadComponent(() => import('./ReportsPage').then((res) => res.ReportsPage));
	const zigZagInteractiveExporter = useLoadComponent(() => import('./zigZag/interactive').then((res) => res.ZigZagInteractiveExporter));
	const addressBook = useLoadComponent(() => import('./addressBook').then((res) => res.ReportsAddressBookPage));
	const backgroundJobs = useLoadComponent(() => import('./backgroundReports').then((res) => res.BackgroundReportsPage));
	return (
		<>
			<Route exact path="/reports" component={reports} />
			<Route exact path="/reports/zigZag" component={zigZagInteractiveExporter} />
			<Route exact path="/reports/addressBook" component={addressBook} />
			<Route exact path="/reports/backgroundJobs" component={backgroundJobs} />
		</>
	);
}
